import React from "react"
import { Badge, Button } from "reactstrap"

export const CustomerAreaHeader = ({
  handleAddNewClick,
  handleRefresh,
  resetParams,
  isRefetching,
  hasActiveFilters,
  total,
}) => {
  return (
    <div className="d-flex align-items-center">
      <h5 className="mb-0 mt-3 card-title flex-grow-1">
        Total <Badge className="badge-soft-info">{total ?? 0}</Badge>
      </h5>
      <div className="flex-shrink-0">
        <Button color="primary" onClick={handleAddNewClick}>
          Add New
        </Button>
        <Button color="light" onClick={handleRefresh} className="ms-1">
          <i className={`mdi mdi-refresh ${isRefetching ? "mdi-spin" : ""}`} />
        </Button>
        {hasActiveFilters && (
          <Button color="danger" onClick={resetParams} className="ms-1">
            Reset Filters
          </Button>
        )}
      </div>
    </div>
  )
}
